var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('app-number-keyboard',{attrs:{"enterFunction":_vm.searchPatient,"title":_vm.getMessage('MSG_INGRESA_NUMERO_DOCUMENTO')}}),_c('app-back-home',{attrs:{"compFrom":'patientSearch'}}),_c('app-loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }